module.exports = __webpack_public_path__ + "static/img/15.766775d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/15.png
// module id = y0PK
// module chunks = 0